import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Input to select the roof pitch
 * @inheritDoc
 */
export class FormModelDirection extends FormModel {

  /**
   * Types fo the roof
   */
  public static readonly ROOF_TYPE_FULL = 'full';
  public static readonly ROOF_TYPE_HALF = 'half';
  public static readonly ROOF_TYPE_PENT = 'pent';

  /**
   * @inheritDoc
   */
  public type = 'direction';

  /**
   * @inheritDoc
   * @param id
   * @param validators
   * @param unit
   * @param value
   * @param info
   * @param roofType
   */
  constructor(id: string, validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true,
              roofType: string = null) {
    super(id, validators, unit, value, info);

    // add a second field for the direction value
    this.fieldData.secondId = id + '_direction';

    this.setRoofType(roofType ?? FormModelDirection.ROOF_TYPE_HALF);
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelDirection {
    // @ts-ignore
    return new this.constructor(this.id, this.validators, this.unit, this.value, this.info);
  }

  /**
   * toggle if we show the full roof or only half roof with panels.
   * @param fieldType
   */
  setRoofType(fieldType: string) {
    this.fieldData.fieldType = fieldType;
  }
}
